export const ALLOCATION_STORES_TABLE_ID = "allocation-store-setup"

export enum AllocationStoreColumn {
  Name = "allocationStoreName",
  Code = "allocationStoreCode",
  Grade = "allocationStoreGrade",
  Format = "allocationStoreFormat",
  Size = "allocationStoreSize",
  SellingArea = "allocationStoreSellingArea",
  TransitTime = "allocationStoreTransitTime",
  DeliveryAddress = "allocationStoreDeliveryAddress",
  Country = "allocationStoreCountry",
  Rule = "allocationStoreRule",
}
